import { useTranslation } from 'react-i18next';
import { Button, Loader, ModalInfo } from '@/components';

import styles from './BehavioralAlertsDeleteRuleModal.module.sass';

interface BehavioralAlertsDeleteRuleModalProps {
  isOpen: boolean;
  name: string;
  isLoading: boolean;
  onClose: () => void;
  onDelete: () => void;
}

export const BehavioralAlertsDeleteRuleModal = ({
  isOpen,
  name,
  isLoading,
  onClose,
  onDelete,
}: BehavioralAlertsDeleteRuleModalProps) => {
  const { t } = useTranslation();

  return (
    <ModalInfo
      isOpen={isOpen}
      canClose={!isLoading}
      title={t('translation.delete_rule.title')}
      actions={
        <div className={styles.actions}>
          <Button
            size="s"
            type="secondary"
            corner="rect"
            minWidth={92}
            onClick={onClose}
          >
            {t('translation.cancel_btn')}
          </Button>

          <Button
            size="s"
            type="secondary-red"
            corner="rect"
            minWidth={92}
            onClick={onDelete}
          >
            {t('translation.yes_delete')}
          </Button>
        </div>
      }
      className={styles.modal}
      onClose={onClose}
    >
      {t('translation.delete_rule.description')} <b>{name}</b> ?
      {isLoading && (
        <div className={styles.loader}>
          <Loader size="medium" />
        </div>
      )}
    </ModalInfo>
  );
};
